import { render, staticRenderFns } from "./header-setting.vue?vue&type=template&id=6240e401&scoped=true&"
import script from "./header-setting.vue?vue&type=script&lang=js&"
export * from "./header-setting.vue?vue&type=script&lang=js&"
import style0 from "./header-setting.vue?vue&type=style&index=0&id=6240e401&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6240e401",
  null
  
)

export default component.exports